export default "__VITE_ASSET__Cmr5KQAA__"